import util from '@bmp-vue/core/api/util'

const controller = 'ClientScopes'
export default Object.assign({}, util.GetCrud(controller, ['getall', 'post', 'put', 'persist', 'delete']))
